import { Controller } from '@hotwired/stimulus';
import TomSelect from "tom-select";

export default class extends Controller {
    static values = {
        cities: Array,
        parcels: Object,
    }
    connect() {
        const cities = this.citiesValue;

        const parcels = this.parcelsValue;

        const citySelect = new TomSelect('#citySelector', {
            maxOptions: null,
            options: cities,
            onChange: updateParcelSelect,
        });

        const parcel = new TomSelect('#parcelSelector', {
            maxOptions: null,
        });

        function updateParcelSelect() {
            const selectedCity = citySelect.getValue();
            const selectedParcels = parcels[selectedCity] || [];

            parcel.clearOptions();
            parcel.addOption(selectedParcels);
        }
    }
}